import React from 'react';
import { InfoWindow, TrafficLayer, withGoogleMap, GoogleMap, Marker, Polyline } from "react-google-maps"
import moment from 'moment-timezone';

export const Map = withGoogleMap((props) => {
  let path;

  if (props.waypoints.length > 30) {
    path = props.waypoints.filter((item, index) => {
      return index % 3 === 0;
    }).map((item, idx) => {
      return {timestamp: item.timestamp, lat: item.position.lat, lng: item.position.lng, mapKey: item.timestamp + idx};
    });
  } else {
    path = props.waypoints.map((item, idx) => {
      return {timestamp: item.timestamp, lat: item.position.lat, lng: item.position.lng, mapKey: item.timestamp + idx};
    });
  }

  return (
    <GoogleMap
      defaultZoom={10}
      defaultCenter={props.center}
    >
      <TrafficLayer autoUpdate />
      {path.map((stop) => {
        return (
          <Marker
            key={stop.mapKey}
            noRedraw
            icon={{url: "/img/waypoint.png", scaledSize: new google.maps.Size(20, 20)}}
            onMouseOut={() => props.onMouseOut()}
            onMouseOver={() => props.onMouseOver(stop.timestamp)}
            position={stop}
          >
            { props.visibleMarker === stop.timestamp && <InfoWindow>
              <div>
                {moment(stop.timestamp).calendar()}
              </div>
            </InfoWindow>
            }
          </Marker>
        );
      })}
      <Polyline
        path={path}
        geodesic={true}
        defaultVisible={true}
        visible={true}
        options={{
          strokeColor: '#25AA82',
          strokeWeight: 2,
        }}
      />
      {props.markers}
    </GoogleMap>
  );
});
